import React, { useState } from "react";
import { Card, Tab, Tabs } from "react-bootstrap";
import CompanyInformation from "./companyInfo";
import ContactInformation from "./contactinfo";
import './profile.css'
import Documents from "./documents";
import UserManagement from "./Users";
const ProfileSettings = () => {
  const [activeTab, setActiveTab] = useState("Company Profile");

  return (
    <div className="container mt-4">
      <h4>Profile Settings</h4>

       <Tabs
      activeKey={activeTab}
      onSelect={(k) => setActiveTab(k)}
      className="mb-3 custom-tabs"
    >
      <Tab eventKey="Company Profile" title="Company Profile">
        <div className="row g-3">
          <div className="col-md-12">
            <CompanyInformation />
          </div>
        </div>
      </Tab>

      <Tab eventKey="Contact Information" title="Contact Information">
        <div className="row g-3">
          <div className="col-md-12">
            <ContactInformation />
          </div>
        </div>
      </Tab>

      <Tab eventKey="Documents" title="Documents">
        <div className="row g-3">
          <div className="col-md-12">
            <Documents />
          </div>
        </div>
      </Tab>

      <Tab eventKey="Users" title="Users">
        <div className="row g-3">
          <div className="col-md-12">
            <UserManagement />
          </div>
        </div>
      </Tab>
    </Tabs>
    </div>
  );
};

export default ProfileSettings;
